import config from '../../../config'

export const BASE_URL = config.api_url
// '//localhost:3000/dev'
export const SORT_ARR = [
  {
    label: 'Pictures First',
    value: 'sortKey=MEDIA_FIRST',
  },
  {
    label: 'Most Recent',
    value: 'sortKey=CREATED',
  },
  {
    label: 'Highest Rating',
    value: 'sortKey=RATING',
  },
  {
    label: 'Lowest Rating',
    value: 'sortKey=RATING&reverse=true',
  },
]

export const STRETCH_ARR = [
  {
    label: 'High Stretch',
    value: 0,
  },
  {
    label: 'Slight Stretch',
    value: 1,
  },
  {
    label: 'No Stretch',
    value: 2,
  },
]

export const FITTING_ARR = [
  {
    label: 'True to Size',
    value: 0,
  },
  {
    label: 'Small',
    value: 1,
  },
  {
    label: 'Large',
    value: 2,
  },
]
